import React from 'react';
import { Tooltip } from '@mui/material';
import { MdEvent, MdInfoOutline } from 'react-icons/md';
import i18n from '../../i18n';
import {
    GROUP_SCHEDULE_CALENDAR_URL,
    TEACHER_ACTIVE_SCHEDULE_CALENDAR_URL,
    TEACHER_SCHEDULE_CALENDAR_URL
} from '../../constants/axios';
import { COMMON_DOWNLOAD_ICS, COMMON_ICS_HINT } from '../../constants/translationLabels/common';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const getCalendarLink = (entityId, semesterId, languageToRequest) => ({
    group: `${BASE_URL}${GROUP_SCHEDULE_CALENDAR_URL}?groupId=${entityId}&semesterId=${semesterId}${languageToRequest}`,
    teacher: `${BASE_URL}${TEACHER_SCHEDULE_CALENDAR_URL}?teacherId=${entityId}&semesterId=${semesterId}${languageToRequest}`,
    teacherActive: `${BASE_URL}${TEACHER_ACTIVE_SCHEDULE_CALENDAR_URL}?teacherId=${entityId}${languageToRequest}`,
});

const CalendarDownloadLink = ({ entity, semesterId, entityId, label, withHint = true }) => {
    if (!entityId || (entity !== 'teacherActive' && !semesterId)) return null;

    const { language } = i18n;
    const languageToRequest = `&language=${language}`;
    const downloadLink = getCalendarLink(entityId, semesterId, languageToRequest)[entity];

    return (
        <>
        <a
        href={downloadLink || ''}
        target="_blank"
        title={i18n.t(COMMON_DOWNLOAD_ICS)}
        aria-label={i18n.t(COMMON_DOWNLOAD_ICS)}
        rel="noreferrer noopener"
        className="calendar_link"
        download
        >
        <MdEvent className="svg-btn" />.ics
        </a>
            {withHint && (
                <Tooltip
                    title={i18n.t(COMMON_ICS_HINT)}
                    arrow
                    enterTouchDelay={0}
                    leaveTouchDelay={8000}
                    slotProps={{ tooltip: { sx: { whiteSpace: 'pre-line', maxWidth: 280 } } }}
                >
        <span className="ics-hint" role="button" tabIndex={0} aria-label={i18n.t(COMMON_ICS_HINT)}>
            <MdInfoOutline />
        </span>
                </Tooltip>
            )}
</>
);
};

export default CalendarDownloadLink;